import {
  LayoutDashboard,
  Package,
  FileSearch,
  MessageSquareText,
  Bot,
  Table,
  Building2,
  UploadCloud,
  Settings,
  Globe,
  type LucideIcon,
} from 'lucide-react'

export interface NavSection {
  label: string
  path: string
  icon: LucideIcon
}

// Order matches docs/design-prds/FIGMA_AI_PROMPT.md "Sections to generate",
// with two deliberate deviations: "Diff & Validation" and "Publish" are
// collapsed into a single "Publish" entry pointing at /diff-validation.
// Publishing is a modal flow reachable from that screen (and the topbar) per
// Frontend PRD 08, not a page of its own - a separate nav item for it led
// nowhere but an empty placeholder. "Field Definitions & Thresholds" has no
// entry of its own either - per Frontend PRD 04, it's the Fields tab inside
// Document Types' detail view, not a separate screen/route. "Prompts" is a
// later addition (Frontend PRD 12) - product-level and document-level prompt
// editing originally lived embedded inside Product Types/Document Types, but
// moved to its own dedicated section per direct user feedback that the
// embedded editors were too hard to find.
export const NAV_SECTIONS: NavSection[] = [
  { label: 'Dashboard', path: '/', icon: LayoutDashboard },
  { label: 'Clients', path: '/client-overrides', icon: Building2 },
  { label: 'Products', path: '/product-types', icon: Package },
  { label: 'Documents', path: '/document-types', icon: FileSearch },
  { label: 'Prompts', path: '/prompts', icon: MessageSquareText },
  { label: 'Extractors', path: '/extractors', icon: Bot },
  { label: 'Lookup Table', path: '/lookup-table', icon: Table },
  { label: 'Global Configs', path: '/global-configs', icon: Globe },
  { label: 'Publish', path: '/diff-validation', icon: UploadCloud },
  { label: 'Settings', path: '/settings', icon: Settings },
]
